// Environment Variables
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';
export const SITE_URL = import.meta.env.VITE_SITE_URL || 'http://localhost:5173';
export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Mashow';

// Helper function to get full URL
export const getFullUrl = (path = '') => {
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

// API Endpoints
export const ENDPOINTS = {
  // Auth
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    ME: '/auth/me',
    LOGOUT: '/auth/logout',
    UPDATE_PASSWORD: '/auth/updatepassword',
    FORGOT_PASSWORD: '/auth/forgotpassword',
    RESET_PASSWORD: '/auth/resetpassword',
    SEND_VERIFICATION_EMAIL: '/auth/sendverificationemail',
    VERIFY_EMAIL: (token) => `/auth/verifyemail/${token}`,
    ENABLE_2FA: '/auth/enable2fa',
    DISABLE_2FA: '/auth/disable2fa',
    VERIFY_2FA: '/auth/verify2fa',
  },
  
  // Products
  PRODUCTS: {
    BASE: '/products',
    FEATURED: '/products/featured',
    NEW_ARRIVALS: '/products/new-arrivals',
    ON_SALE: '/products/on-sale',
    BY_SLUG: (slug) => `/products/slug/${slug}`,
    BY_ID: (id) => `/products/${id}`,
  },
  
  // Categories
  CATEGORIES: {
    BASE: '/categories',
    BY_SLUG: (slug) => `/categories/slug/${slug}`,
    BY_ID: (id) => `/categories/${id}`,
  },
  
  // Cart
  CART: {
    BASE: '/cart',
    ITEM: (itemId) => `/cart/${itemId}`,
    COUPON: '/cart/coupon',
  },
  
  // Orders
  ORDERS: {
    BASE: '/orders',
    BY_ID: (id) => `/orders/${id}`,
    CANCEL: (id) => `/orders/${id}/cancel`,
    STATUS: (id) => `/orders/${id}/status`,
    SHIPPING: (id) => `/orders/${id}/shipping`,
  },
  
  // Reviews
  REVIEWS: {
    BASE: '/reviews',
    PRODUCT: (productId) => `/reviews/product/${productId}`,
    BY_ID: (id) => `/reviews/${id}`,
    VOTE: (id) => `/reviews/${id}/vote`,
    APPROVE: (id) => `/reviews/${id}/approve`,
    RESPONSE: (id) => `/reviews/${id}/response`,
  },
  
  // User
  USER: {
    PROFILE: '/users/profile',
    ADDRESSES: '/users/addresses',
    ADDRESS: (id) => `/users/addresses/${id}`,
  },
  
  // Admin
  ADMIN: {
    DASHBOARD: '/admin/dashboard',
    ORDERS: '/admin/orders',
    USERS: '/admin/users',
    REVIEWS: '/admin/reviews',
    USER: (id) => `/admin/users/${id}`,
  },
  
  // Wishlist
  WISHLIST: {
    BASE: '/wishlist',
    ITEM: (itemId) => `/wishlist/${itemId}`,
  },
  
  // Campaigns
  CAMPAIGNS: {
    BASE: '/campaigns',
    BY_ID: (id) => `/campaigns/${id}`,
    VALIDATE: '/campaigns/validate',
    ACTIVE: '/campaigns/active',
  },
  
  // Upload
  UPLOAD: {
    SINGLE: '/upload',
    MULTIPLE: '/upload/multiple',
  },
  
  // Settings
  SETTINGS: {
    BASE: '/settings',
    UPLOAD_LOGO: '/settings/upload-logo',
    UPLOAD_FAVICON: '/settings/upload-favicon',
  },
  
  // Captcha
  CAPTCHA: {
    GENERATE: '/captcha/generate',
    VERIFY: '/captcha/verify',
  },
};

